$(function(){
    $('[js-deposit-form-open]').on('click', function(e){
        e.preventDefault();
        $$.openModal($('[js-deposit-modal]'), {
            afterOpen: function(api, $modal){
                var $form = $modal.find('[js-deposit-form]');
                $form.formHandle({
                    beforeData: function(){
                        $$.blockOverlay($modal);
                    },
                    afterData: function(modal, data){
                        if(data.error){
                            $$.blockOverlay($modal);
                        }
                    },
                    success: function(data){
                        if(data.redirect){
                            location.href = data.redirect;
                        }else{
                            if(data.error){
                                $$.alert(data.error)
                            }else{
                                $$.alert('Что-то пошло не так. Попробуйте позже.')
                            }

                        }
                    }
                });
            }
        });
    });
});